import { render, staticRenderFns } from "./AddFarmModal.vue?vue&type=template&id=280fa31c"
import script from "./AddFarmModal.vue?vue&type=script&lang=js"
export * from "./AddFarmModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports